(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBrandDirectory(root) {
      var searchInput = root.querySelector('[data-bd-search]');
      var azNav = root.querySelector('[data-bd-az-nav]');
      var noResults = root.querySelector('[data-bd-no-results]');
      var resultCount = root.querySelector('[data-bd-count]');
      var groups = root.querySelectorAll('.bd-letter-group');
      var totalBrands = root.querySelectorAll('.bd-brand-link').length;

      var letters = [];
      groups.forEach(function (g) { letters.push(g.dataset.letter); });

      function g_id(letter) {
        return root.id.replace('brand-directory-', 'bd-letter-') + '-' + letter;
      }

      azNav.innerHTML = letters.map(function (l) {
        return '<button class="bd-az-btn" data-target="' + g_id(l) + '">' + l + '</button>';
      }).join('');

      function updateCount(visible) {
        if (!resultCount) return;
        resultCount.textContent = visible === totalBrands
          ? totalBrands + ' brands'
          : visible + ' of ' + totalBrands + ' brands';
      }
      updateCount(totalBrands);

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          var q = searchInput.value.trim().toLowerCase();
          var visibleCount = 0;

          groups.forEach(function (group) {
            var groupHasMatch = false;
            group.querySelectorAll('.bd-brand-item').forEach(function (item) {
              var match = item.dataset.name.indexOf(q) !== -1;
              item.style.display = match ? '' : 'none';
              if (match) { groupHasMatch = true; visibleCount++; }
            });
            group.style.display = groupHasMatch ? '' : 'none';
          });

          azNav.querySelectorAll('.bd-az-btn').forEach(function (btn) {
            var target = document.getElementById(btn.dataset.target);
            var hasVisible = target && target.style.display !== 'none';
            btn.classList.toggle('disabled', !hasVisible);
          });

          if (noResults) noResults.style.display = visibleCount === 0 ? 'block' : 'none';
          updateCount(visibleCount);
        });
      }

      azNav.addEventListener('click', function (e) {
        var btn = e.target.closest('.bd-az-btn');
        if (!btn || btn.classList.contains('disabled')) return;
        var target = document.getElementById(btn.dataset.target);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // --- Multi-brand selection ---
      var genderTag = root.dataset.gender;
      var selectionBar = root.querySelector('[data-bd-selection-bar]');
      var selectionCount = root.querySelector('[data-bd-selection-count]');
      var selectionView = root.querySelector('[data-bd-selection-view]');
      var selectionClear = root.querySelector('[data-bd-selection-clear]');
      var checkboxes = root.querySelectorAll('[data-bd-brand-checkbox]');

      function selectedItems() {
        var items = [];
        checkboxes.forEach(function (cb) {
          if (cb.checked) items.push(cb.closest('.bd-brand-item'));
        });
        return items;
      }

      function buildSearchUrl(items) {
        var params = new URLSearchParams();
        params.set('q', '*');
        params.set('type', 'product');
        if (genderTag) params.append('filter.p.tag', genderTag);

        var seenVendors = {};
        items.forEach(function (item) {
          var vendors = (item.dataset.vendors || '').split('||');
          vendors.forEach(function (v) {
            v = v.trim();
            if (v && !seenVendors[v]) {
              seenVendors[v] = true;
              params.append('filter.p.vendor', v);
            }
          });
        });

        return '/search?' + params.toString();
      }

      function refreshSelectionBar() {
        var items = selectedItems();
        if (items.length === 0) {
          selectionBar.hidden = true;
          return;
        }
        selectionBar.hidden = false;
        selectionCount.textContent = items.length === 1
          ? '1 brand selected'
          : items.length + ' brands selected';
        selectionView.setAttribute('href', buildSearchUrl(items));
        selectionView.textContent = 'View ' + items.length + (items.length === 1 ? ' Brand' : ' Brands');
      }

      checkboxes.forEach(function (cb) {
        cb.addEventListener('change', refreshSelectionBar);
      });

      if (selectionClear) {
        selectionClear.addEventListener('click', function () {
          checkboxes.forEach(function (cb) { cb.checked = false; });
          refreshSelectionBar();
        });
      }

      refreshSelectionBar();
    }

    document.querySelectorAll('.brand-directory').forEach(initBrandDirectory);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
